/**
 * Documents API Client for Admin Dashboard
 * Stats-only endpoint (admin aggregation)
 */

import apiClient from './client';

export interface DocumentStats {
  total_documents: number;
  documents_by_status: Record<string, number>;
  total_storage_bytes: number;
  total_chunks: number;
}

export const documentsApi = {
  async getStats(): Promise<DocumentStats> {
    const response = await apiClient.get<DocumentStats>('/documents/stats');
    return response.data;
  },
};
